import { render, staticRenderFns } from "./Placeholders.html?vue&type=template&id=864a2d74&scoped=true&external"
import script from "./Placeholders.vue?vue&type=script&lang=js"
export * from "./Placeholders.vue?vue&type=script&lang=js"
import style0 from "./Placeholders.scss?vue&type=style&index=0&id=864a2d74&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "864a2d74",
  null
  
)

export default component.exports